<template>
  <el-button
    :class="`gradient_btn ${white?'white_btn':''}${$i18n.locale=='PT'?' gradient_btn_pt':''}`"
    @click="$emit('click')"
    :disabled="disabled"
    :loading="loading"
    :style="mStyle"
  >
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    loading: Boolean,
    white: Boolean,
    mStyle: String,
  },
};
</script>

<style lang="scss" scoped>
.gradient_btn {
  color: #5ba7ad;
  font-size: 18px;
  font-weight: 500;
  background: #fff;
  border-radius: 4px;
  border: 1px solid rgba(91, 167, 173, 1);
  width: 202px;
  /deep/.el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    opacity: 0.5;
  }
}
.white_btn {
  border: 1px solid rgba(91, 167, 173, 1);
  background: #fff;
  color: #5ba7ad;
}
.gradient_btn:hover {
  background: #5ba7ad;
  color: #fff;
}
.white_btn:hover {
  background: #5ba7ad;
  color: #fff;
}
.gradient_btn.is-disabled,
.gradient_btn.is-disabled:focus,
.gradient_btn.is-disabled:hover {
  background: #5ba7ad;
  opacity: 0.5;
  color: #fff;
  border: 1px solid rgba(91, 167, 173, 1);
}
</style>